import * as React from 'react';

import { translate } from '~l10n/client';
import { useDispatch } from 'react-redux';

import { SmallButton } from '~shared/components/buttons';
import { IconPlus } from '~shared/components/icons/standard';

import { addAnswerToQuestion } from '../../slices/quiz/quizSlice';
import QuestionShortAnswerEditAnswer from './QuestionShortAnswerEditAnswer';

interface Props {
  answerIds: (string | number)[];
  isDisabled: boolean;
}

const QuestionShortAnswerEdit = ({ answerIds, isDisabled }: Props) => {
  const dispatch = useDispatch();
  const handleAddItem = React.useCallback(() => {
    dispatch(addAnswerToQuestion({}));
  }, [dispatch]);
  const addAnswerText = translate('Add Answer');

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 p-0 short-answer__fields">
        {answerIds.map((answerId) => (
          <QuestionShortAnswerEditAnswer answerId={answerId} key={answerId} />
        ))}
      </div>
      <div className="mt-4">
        <SmallButton
          isOnWhite={false}
          onClick={handleAddItem}
          isDisabled={isDisabled}
        >
          <span className="inline-flex mr-1 -ml-2 text-inherit">
            <IconPlus />
          </span>
          {addAnswerText}
        </SmallButton>
      </div>
    </>
  );
};

export default QuestionShortAnswerEdit;
